// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"8f80a7cd","488":"c9aa2409"}[chunkId] + ".chunk.js";
};